import { render, staticRenderFns } from "./sidebar.html?vue&type=template&id=f432a0ea&"
import script from "./sidebar.js?vue&type=script&lang=js&"
export * from "./sidebar.js?vue&type=script&lang=js&"
import style0 from "./sidebar.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports